import React from "react";
import { useTranslation } from "react-i18next";
import AbstractCommand from "./AbstractCommand";
import AbstractClientCommand from "./clientCommand/AbstractClientCommand";

const SystemCommandList = ({ notification, setNotification }) => {

  const { t } = useTranslation("systemCommandsPage");

  return (
    <>
      <AbstractCommand
        notification={notification}
        setNotification={setNotification}
        commandUrl="cache-clear"
        description="Cache clear"
      />
      <AbstractCommand
        notification={notification}
        setNotification={setNotification}
        commandUrl="doctrine-schema-update"
        description="Doctrine schema update"
      />
      <AbstractClientCommand
        t={t}
        notification={notification}
        setNotification={setNotification}
        commandUrl="create-fee"
        description="Create fee"
      />
      <AbstractClientCommand
        t={t}
        notification={notification}
        setNotification={setNotification}
        commandUrl="create-range-fee"
        description="Create range fee"
      />
      <AbstractCommand
        notification={notification}
        setNotification={setNotification}
        commandUrl="create-rates"
        description="Create rates"
      />
      <AbstractClientCommand
        t={t}
        notification={notification}
        setNotification={setNotification}
        commandUrl="fill-user-services"
        description="Fill user services"
      />
      <AbstractClientCommand
        t={t}
        notification={notification}
        setNotification={setNotification}
        commandUrl="fill-project-verification-schema"
        description="Fill project verification schema"
      />
      <AbstractCommand
        notification={notification}
        setNotification={setNotification}
        commandUrl="update-transaction-attribute-regex-placeholder"
        description="Update transaction attribute regex placeholder"
      />
      <AbstractCommand
        notification={notification}
        setNotification={setNotification}
        commandUrl="fill-exchange-pairs"
        description="Fill exchange pairs"
      />
      <AbstractClientCommand
        t={t}
        notification={notification}
        setNotification={setNotification}
        commandUrl="fill-user-exchange-pairs"
        description="Fill user exchange pairs"
      />
      <AbstractCommand
        notification={notification}
        setNotification={setNotification}
        commandUrl="create-master-balances"
        description="Create master balances"
      />
    </>
  );
};

export default SystemCommandList;